export const isEmptyObject = (obj: any): boolean => {
  // First, check if the value is actually an object and not null or undefined
  if (typeof obj !== 'object' || obj === null) {
    return false; // Or throw an error, depending on expected input
  }

  // Get an array of the object's own enumerable property names
  const keys = Object.keys(obj);

  // If the length of this array is 0, the object is empty
  return keys.length === 0;
};
